import React from "react";
import PropTypes from "prop-types";
import { Label } from "reactstrap";
import styled from "styled-components";

const CheckboxCollapse = ({
  defaultChecked = false,
  children,
  title = "",
  id,
  end,
  name = "",
  style = {
    marginBottom: "10.5px",
  },
  isDisabled = false,
  onChange = () => {},
}) => {
  const [checked, setChecked] = React.useState(defaultChecked);

  const handleChange = e => {
    setChecked(e.target.checked);
    onChange(e.target.checked);
  };

  return (
    <>
      <StyledInput
        name={name}
        className={`form-check-input mr-1 ${isDisabled && 'is_disabled'}`}
        style={{
          ...style,
        }}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={isDisabled}
        id={id}
      />
      <span
        className="text-muted"
        style={{
          fontFamily: "Poppins, sans-serif",
          fontSize: "13px",
          fontWeight: "500",
          color: "rgb(116, 120, 141)",
        }}
      >
        {title}
      </span>
      {!end && ":"}
      {checked && children}
    </>
  );
};

const StyledInput = styled.input`

 .is_disabled {
  background-color: rgb(242, 242, 242) !important;
 }

 &.is_disabled {
  background-color: rgb(242, 242, 242) !important;
 }

`

CheckboxCollapse.propTypes = {
  defaultChecked: PropTypes.bool,
  children: PropTypes.any,
  title: PropTypes.any,
  name: PropTypes.string,
  id: PropTypes.string.isRequired,
  end: PropTypes.bool,
  onChange: PropTypes.func,
  style: PropTypes.object,
  isDisabled: PropTypes.bool,
};

export default CheckboxCollapse;
